const BanzaRadioPresets = {
  BanzaRadio: {
    attrs: {
      density: "compact"
    },
    presets: {}
  }
};
export {
  BanzaRadioPresets as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQmFuemFSYWRpb1ByZXNldHMuanMiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb25zdGFudHMvY29tcG9uZW50cy9CYW56YVJhZGlvUHJlc2V0cy5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCB7XG5cdEJhbnphUmFkaW86IHtcblx0XHRhdHRyczoge1xuXHRcdFx0ZGVuc2l0eTogXCJjb21wYWN0XCIsXG5cdFx0fSxcblx0XHRwcmVzZXRzOiB7fSxcblx0fSxcbn07XG4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsTUFBZSxvQkFBQTtBQUFBLEVBQ2QsWUFBWTtBQUFBLElBQ1gsT0FBTztBQUFBLE1BQ04sU0FBUztBQUFBLElBQ1Q7QUFBQSxJQUNELFNBQVMsQ0FBRTtBQUFBLEVBQ1g7QUFDRjsifQ==
